export const eventMargin = 16
export const eventControlsMargin = 24